import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from '@angular/core'

@Component({
  selector: 'app-mobile-accordion',
  standalone: true,
  imports: [NgClass],
  templateUrl: './mobile-accordion.component.html',
  styleUrl: './mobile-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileAccordionComponent implements OnInit {
  public readonly title = input.required<string>()
  public readonly expanded = input(true)
  public readonly isLast = input(false)
  public readonly expandedChange = output<boolean>()

  public readonly isExpanded = signal(true)

  ngOnInit(): void {
    this.isExpanded.set(this.expanded())
  }

  /**
   * Toggles the accordion.
   */
  public toggle(): void {
    const next = !this.isExpanded()
    this.isExpanded.set(next)
    this.expandedChange.emit(next)
  }
}
